var exports = {
  "x6": "xa15a2ab7--f52a34--button",
  "DD": "xa15a2ab7--f52a34--title",
  "mb": "xa15a2ab7--f52a34--redesign",
};

module.exports = exports;
